export * from "./SolitaireCore";
export { default } from "./SolitaireCore";
